import * as React from 'react';
import { isfunc } from 'piral-base';
import { useGlobalState } from '../hooks';
import { defaultRender, none } from '../utils';
/**
 * The extension slot component to be used when the available
 * extensions of a given name should be rendered at a specific
 * location.
 */
export function ExtensionSlot(props) {
    const { name, render = defaultRender, empty, params } = props;
    const extensions = useGlobalState((s) => s.registry.extensions[name] || none);
    return render(extensions.length === 0 && isfunc(empty)
        ? [defaultRender(empty(), 'empty')]
        : extensions.map(({ component: Component, reference, defaults = {} }, i) => (React.createElement(Component, { key: `${(reference === null || reference === void 0 ? void 0 : reference.displayName) || '_'}${i}`, params: Object.assign(Object.assign({}, defaults), (params || {})) }))));
}
ExtensionSlot.displayName = `ExtensionSlot`;
//# sourceMappingURL=ExtensionSlot.js.map